'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _utils = require('../utils');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {}
  }, {
    key: 'preload',
    value: function preload() {}
  }, {
    key: 'create',
    value: function create() {
      var txt = _config2.default.levels[_config2.default.state.map].desc;
      this.text = this.add.text(this.game.width / 2.0, this.game.height / 2.0, txt, { font: '24px Belgrano', fill: '#aa0000', align: 'center' });
      this.text.alpha = 0.0;
      this.game.add.tween(this.text).to({ alpha: 1 }, 1000, "Linear", true);
      this.text.anchor.setTo(0.5, 0.5);
      this.totalTime = 3.0;
      this.space = this.game.input.keyboard.addKey(_phaser2.default.Keyboard.SPACEBAR);
      this.game.input.keyboard.addKeyCapture([_phaser2.default.Keyboard.SPACEBAR]);
    }
  }, {
    key: 'update',
    value: function update() {
      var dt = this.game.time.physicsElapsed;
      this.totalTime -= dt;
      if (this.totalTime <= 1.0 && this.totalTime > 0.0) {
        this.text.alpha = this.totalTime;
      }
      if (this.totalTime <= 0.0 || this.space.isDown) {
        this.state.start('Game');
      }
    }
  }]);

  return _class;
}(_phaser2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Warp.js
// module id = 131
// module chunks = 0